


<div class="px-3">
  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">
  
      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-envelope font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Comms Blockout Settings</div>
        <div class="text-right mt-2">Manage comms blockout settings</div>
      </div>
      
    </div>
  </div>
  
  <div [style.display]="isShowProgressSpinner ? 'block' : 'none'" class="loadingContainer">
    <div class="overlay">
      <p-progressSpinner strokeWidth="7" class="spinner"></p-progressSpinner>
    </div>
  </div>
  
  <div class="flex justify-content-between mt-7 px-3">
    <div class="flex align-items-center gap-1">
      <p-multiSelect [options]="creditors"
                   [(ngModel)]="selectedCreditors"
                   (ngModelChange)="onChangeCreditor($event)"
                   placeholder="Select Creditors"
                   optionLabel="CompanyName"
                   filterBy="CreditorId,CompanyName"
                   
                   >
              <ng-template let-creditor pTemplate="item">
                  <div class="flex align-items-center justify-content-between flex-1">
                      <div>{{ creditor.CompanyName }}</div>
                      <div class="ml-2">{{ creditor.CreditorId }}</div>
                  </div>
              </ng-template>
      </p-multiSelect>
      <remitter-button
        (click)="search()" 
        label="Get"
        icon="search"  
        styleClass='ml-2'                                
      /> 
    </div> 
    <remitter-button
        (click)="onOpenSideBar()" 
        label='Add New'
        icon='plus'  
        severity='info'                               
      /> 
  </div>
  
  <div class="mt-4 pt-2 px-3">
    <div 
    *ngIf="!hasTableData && hasClickedSearch"  
    style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
              🚫 No records found for creditors.
    </div>
    <p-table 
          *ngIf="hasTableData"
          [value]="commsBlockoutSettings" [paginator]="true"
                                             [rows]="5"
                                             [tableStyle]="{ 'min-width': '50rem' }"
                                             [rowsPerPageOptions]="[5, 10, 20]">
          
          <ng-template pTemplate="header">
              <tr>
                  <th>Creditor Id</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Zip Code</th>
                  <th>Is Active</th>
                  <th>Reason</th>
                  <th>Action</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-comms>
              <tr>
                  <td>{{ comms.CreditorId }}</td>
                  <td>{{ comms.StartDate | date:'yyyy-MM-dd'}}</td>
                  <td>{{ comms.EndDate | date:'yyyy-MM-dd'}}</td>
                  <td>{{ comms.ZipCode }}</td>
                  <td>{{ comms.IsActive }}</td>
                  <td>{{ comms.Reason }}</td>
                  <td>
                    <div class="flex align-items-center">
                      <icon-button
                        pTooltip="Edit"
                        tooltipPosition='left'
                        (click)="onOpenSideBar(comms.Id, comms.CreditorId, comms.StartDate, comms.EndDate, comms.ZipCode, comms.IsActive, comms.Reason )"
                        [icon]="'pencil'"
                        [styleClass]="'mr-1'"
                       />  
                      
                       <icon-button
                        pTooltip='Delete'
                        tooltipPosition='left'
                        (click)="onOpenDeleteModal(comms.CreditorId, 'commsBlockout')"
                        [icon]="'trash'"
                      />
                    </div>
                  </td>
              </tr>
          </ng-template>
      </p-table>
  </div>
</div>

<p-dialog header="Delete Confirmation" [(visible)]="isDeleteModalVisible" [style]="{width: '30vw'}">
 <div class="text-center">Are you sure you want to delete this {{toDeleteType === 'zipCode'? 'Zip codes' : 'Comms Block Setting' }}?</div>
 <div class="flex justify-content-end mt-4">
    <remitter-button
      (click)="onConfirmDelete()" 
      label='Yes'
      icon='check'                                         
    />   
 </div>
</p-dialog>

 <p-sidebar [(visible)]="isSideBarVisible" styleClass="w-6" position="right">
  <div class="bg-white shadow-3 border-round p-4">
    <div class="text-xl">{{toEditId? 'Edit ' : 'Add New '}} Comms Blockout</div>

    <div class="mt-5">
      <p-floatLabel>
        <p-autoComplete 
           styleClass="w-full"
           [(ngModel)]="selectedCreditor" 
           [suggestions]="filteredCreditors"  
           (completeMethod)="filterCreditors($event)" 
           (onSelect)="onSelectCreditor($event)"
           [dropdown]="true" 
           optionLabel="CompanyName"
           placeholder="Select Creditor"
           id="creditors"
           >
           <ng-template let-creditor pTemplate="item">
             <div class="flex align-items-center justify-content-between flex-1">
              <div>{{creditor.CompanyName}}</div>
  
              <div>{{creditor.CreditorId}}</div>
             </div>
            </ng-template>
        </p-autoComplete>
        <label for="creditors">Creditor</label>
      </p-floatLabel>
    </div>

    <div class="mt-4 flex justify-content-between align-items-center">
      <div class="flex align-items-center">
        <div>Zip Code CSV File:</div>
        <!--accept=".csv"-->
        <input type="file" #fileInput (change)="onFileSelected($event)"  style="display: none;" />
        <remitter-button
          (click)="fileInput.click()" 
          label='Upload'
          icon='file'   
          styleClass='ml-2'    
          severity='secondary'                                  
        /> 
      </div>

      <div class="flex align-items-center">
        <div>Is Active:</div>
        <p-inputSwitch [(ngModel)]="isActive" />
      </div>

    </div>
    
    <div class="grid mt-4 px-2">
      <div class="col-10 text-xs font-semibold surface-50 border-bottom-1 border-300">
          Zip Codes
      </div>

      <div class="col-2 text-xs font-semibold surface-50 border-bottom-1 border-300">
          Action
      </div>
  </div>
  <div class="grid mt-1">
    <div class="col-10">
        {{zipCode}}
    </div>

    <div class="col-2">
      <i *ngIf="!!zipCode" class="pi pi-trash text-xs cursor-pointer" pTooltip="Delete" tooltipPosition="left" (click)="onOpenDeleteModal(null, 'zipCode')"></i>
    </div>
   </div>
  
  <textarea class="w-full mt-4" rows="5" cols="30" pInputTextarea placeholder="Reason" [(ngModel)]="reason"></textarea>
  
  <div class="flex align-items-center gap-3 mt-4">
    <div>Blockout Date Range:</div>
    <p-calendar 
      [(ngModel)]="startDate" 
      placeholder="From Date"
      [maxDate]="endDate"
    >
    </p-calendar>
    <p-calendar 
      placeholder="To Date"
      [(ngModel)]="endDate"        
      [minDate]="startDate"
     />
  </div>

    <div class="flex justify-content-end mt-4">
      <remitter-button
        (click)="onSave()" 
        label='Save'
        icon='send'                                   
      /> 
    </div>
  </div>
</p-sidebar>




